import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CommonUiProductsModule } from '@innogy/common-ui/products';
import {
  DefaultComponentModule,
  DefaultFormComponentModule,
} from '@innogy/core/modules/components';
import { FehSharedLazyModule } from '@innogy/feh/shared';
import { provideLazyLoad, TextInterpolationPipe } from '@core/jss-utils';
import { SitecoreFormsModule } from '@innogy/sitecore-forms';
import { CSMaskDirective } from '@legacy/utils-contentsquare';
import { IsInvalidPipe } from '@innogy/utils-deprecated';

import { InsulationOrderFormComponent } from './components/insulation-order-form/insulation-order-form.component';
import { InsulationProductOverviewComponent } from './components/insulation-product-overview/insulation-product-overview.component';
import { InsulationReceiptComponent } from './components/insulation-receipt/insulation-receipt.component';
import { InsulationWizardContainerComponent } from '../../../../feh/insulation/src/lib/components/insulation-wizard-container/insulation-wizard-container.component';

@NgModule({
  imports: [
    DefaultComponentModule,
    DefaultFormComponentModule,
    CommonModule,
    CommonUiProductsModule,
    SitecoreFormsModule,
    FehSharedLazyModule,
    provideLazyLoad({
      InsulationWizard: InsulationWizardContainerComponent,
      InsulationProductOverview: InsulationProductOverviewComponent,
      InsulationReceipt: InsulationReceiptComponent,
      InsulationOrderForm: InsulationOrderFormComponent,
    }),
    TextInterpolationPipe,
    CSMaskDirective,
    IsInvalidPipe,
  ],
  declarations: [
    InsulationWizardContainerComponent,
    InsulationReceiptComponent,
    InsulationOrderFormComponent,
    InsulationProductOverviewComponent,
    InsulationWizardContainerComponent,
  ],
  exports: [],
})
export class InsulationLazyModule {}
